import { rgba } from 'polished';
import styled, { DefaultTheme } from 'styled-components';
import { Flex, token } from '@bynder/design-system';
import { GUIDELINES_HEADER_HEIGHT, VISUALS } from '../../../constants/styles';
import { getTypographyWeight } from './constants';
import { StyledSavingStatus } from '../../guides/GuideSavingStatus';
import { StyledGuideOwner } from '../../guides/GuideOwner';
import { StyledBulletPoint } from '../BulletPoint';
import { isValidHexCode } from '../../../helpers/colors';
import { addQuotes, toPx } from '../../guides/Inspector/helpers';

export const getAlphaColor = (amount: number, hexCode: string) => {
  if (!isValidHexCode(hexCode) || !hexCode?.length) {
    return 'inherit';
  }

  return `${rgba(hexCode, amount)} !important`;
};

export const StyledHeader = styled.header(({ theme }) => {
  const { getValueOrDefault } = theme;

  return `
    position: fixed;
    top: ${VISUALS.BYNDER_HEADER_HEIGHT};
    right: 0;
    left: 0;
    width: 100%;
    z-index: 98;
    height: ${GUIDELINES_HEADER_HEIGHT};
    min-height: ${GUIDELINES_HEADER_HEIGHT};
    padding: 0 ${token.spacing6} 0 ${token.spacing5};
    background-color: ${getValueOrDefault(
    'navigationBar.backgroundColor.hexCode',
  )};
    border-bottom: 1px solid ${getValueOrDefault(
    'navigationBar.borderColor.hexCode',
  )};
    flex-wrap: nowrap;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-shadow: ${token.elevation2};

    > button {
      width: 48px;
      height: 40px;
      color: ${getAlphaColor(
    0.6,
    getValueOrDefault('navigationBar.textColor.hexCode'),
  )};

      &:hover {
        color: ${getValueOrDefault(
    'navigationBar.textColor.hexCode',
  )} !important;
        background-color: ${getAlphaColor(
    0.03,
    getValueOrDefault('navigationBar.textColor.hexCode'),
  )};
      }

      &:active {
        color: ${getValueOrDefault(
    'navigationBar.textColor.hexCode',
  )} !important;
        background-color: ${getAlphaColor(
    0.05,
    getValueOrDefault('navigationBar.textColor?.hexCode'),
  )};
      }
    }
  `;
});

export const StyledHeaderContainer = styled.div<{
  theme: DefaultTheme;
  $isEditMode: boolean;
}>(({ theme, $isEditMode }) => {
  const { getValueOrDefault } = theme;

  return `
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;

    & > :first-child {
      margin-left: ${token.spacing4};
    }

    h1 {
      color: ${getValueOrDefault('navigationBar.textColor.hexCode')};
      margin-top: 0;
      font-size: ${$isEditMode ? toPx(18) : toPx(22)};
      font-weight: normal;
      line-height: 1.5em;
    }


    ${StyledSavingStatus} {
    color: ${getAlphaColor(
    0.6,
    getValueOrDefault('navigationBar.textColor.hexCode'),
  )};
    }

    ${StyledBulletPoint} {
      color: ${getAlphaColor(
    0.6,
    getValueOrDefault('navigationBar.textColor.hexCode'),
  )};
    }

    ${StyledGuideOwner} {
      color: ${getAlphaColor(
    0.6,
    getValueOrDefault('navigationBar.textColor.hexCode'),
  )};
    } 
  `;
});

export const StyledHeaderInfo = styled.div(({ theme }) => {
  const { getValueOrDefault } = theme;

  return `
    min-width: 0;
    flex: 1 0 auto;
    margin-left: ${token.spacing5};
    max-width: 410px;

    > h1 {
      font-family: ${addQuotes(getValueOrDefault('navigationBar.fontFamily'))};
      font-weight: ${getTypographyWeight(
    theme,
    getValueOrDefault('navigationBar.fontFamily'),
    getValueOrDefault('navigationBar.fontStyle'),
  )};
      font-size: ${getValueOrDefault('navigationBar.fontSize')}px;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `;
});

export const StyledPublishContainer = styled(Flex)`
  label {
    color: ${({ theme }) =>
    theme.getValueOrDefault('navigationBar.textColor.hexCode')};
  }
`;
